<template>
  <el-dialog :title="title" :visible.sync="visible" width="800px" @close="handleClose">
    <el-form :model="form" ref="form" :rules="rules" label-width="150px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="库区名称" prop="reservoirAreaName">
            <el-select v-model="form.reservoirAreaName" @change="changeReservoirArea" clearable :disabled="isEdit">
              <el-option v-for="item in reservoirAreaOptions" :key="item.reservoirAreaCode"
                :label="item.reservoirAreaName" :value="item.reservoirAreaName">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="油罐编码" prop="oilTankCode">
            <el-select v-model="form.oilTankCode" @change="changeOilTank" clearable :disabled="isEdit">
              <el-option v-for="item in diaOilTankOptions" :key="item.oilTankCode" :label="item.oilTankCode"
                :value="item.oilTankCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="合理损耗率" prop="lossRate">
            <el-input-number class="form-input" v-model="form.lossRate" controls-position="right"
              :precision="3"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="当月实际库存" prop="practicalQuantity">
            <el-input-number class="form-input" v-model="form.practicalQuantity" controls-position="right"
              :precision="3" @change="changeOperateDate"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="助剂账面数" prop="additiveAccount">
            <el-input-number class="form-input" v-model="form.additiveAccount" controls-position="right"
              :precision="3" @change="calculateAdditiveQuantity"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="助剂使用数" prop="additiveUse">
            <el-input-number class="form-input" v-model="form.additiveUse" controls-position="right"
              :precision="3" @change="calculateAdditiveQuantity"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="助剂库存数" prop="additiveQuantity">
            <el-input-number class="form-input" v-model="form.additiveQuantity" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="盘点时间" prop="operateDate">
            <el-date-picker v-model="form.operateDate" type="datetimerange" range-separator="至" start-placeholder="开始时间"
              end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" :defaultTime="['00:00:00', '23:59:59']" @change="handleOperateDateChange">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="期初实存" prop="realityOpeningQuantity">
            <el-input-number class="form-input" v-model="form.realityOpeningQuantity" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="理论期初库存" prop="systemOpeningQuantity">
            <el-input-number class="form-input" v-model="form.systemOpeningQuantity" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="理论入库量" prop="systemInQuantity">
            <el-input-number class="form-input" v-model="form.systemInQuantity" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="理论出库量" prop="systemOutQuantity">
            <el-input-number class="form-input" v-model="form.systemOutQuantity" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="理论库存" prop="systemEndingQuantity">
            <el-input-number class="form-input" v-model="form.systemEndingQuantity" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="合理损耗" prop="realityWastage">
            <el-input-number class="form-input" v-model="form.realityWastage" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="期末累计实存" prop="realityEndingQuantityTotal">
            <el-input-number class="form-input" v-model="form.realityEndingQuantityTotal" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="月度盘盈" prop="realityProfit">
            <el-input-number class="form-input" v-model="form.realityProfit" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="月度盘亏" prop="realityLoss">
            <el-input-number class="form-input" v-model="form.realityLoss" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="损耗差异" prop="realityWastageDiff">
            <el-input-number class="form-input" v-model="form.realityWastageDiff" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="损耗率" prop="realityWastageRatio">
            <el-input-number class="form-input" v-model="form.realityWastageRatio" controls-position="right"
              :precision="3" disabled></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="23">
          <el-form-item label="备注" prop="memo">
            <el-input type="textarea" :rows="2" v-model="form.memo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import HttpUtil from '@/common/HttpUtil'
export default {
  name: 'addOrEditDialog',
  props: [
    'show',
    'info',
    'reservoirAreaOptions',
    'oilTankOptions',
    'oilTankData',
    'reload'
  ],
  components: {
  },
  data () {
    return {
      visible: false,
      form: {
        id: null,
        reservoirAreaCode: '',
        reservoirAreaName: '',
        oilTankCode: '',
        lossRate: null,
        practicalQuantity: null,
        additiveAccount: null,
        additiveUse: null,
        additiveQuantity: null,
        operateDate: new Date(),
        memo: '',
        realityOpeningQuantity: null,
        systemOpeningQuantity: null,
        systemInQuantity: null,
        systemOutQuantity: null,
        systemEndingQuantity: null,
        realityEndingQuantityTotal: null,
        realityProfit: null,
        realityLoss: null,
        realityWastage: null,
        realityWastageDiff: null,
        realityWastageRatio: null,
        realityAidsUse: null,
        realityAidsQuantity: null,
        // 罐底油
        tankBottomQuantity: null
      },
      rules: {
        oilTankCode: [{ required: true, message: '请选择油罐编码' }],
        reservoirAreaName: [{ required: true, message: '请选择库区' }],
        lossRate: [{ required: true, message: '请录入合理损耗率' }],
        practicalQuantity: [{ required: true, message: '请录入当月实际库存' }],
        additiveAccount: [{ required: true, message: '请录入助剂账面数' }],
        additiveUse: [{ required: true, message: '请录入助剂使用数' }],
        additiveQuantity: [{ required: true, message: '请录入助剂库存数' }],
        operateDate: [{ required: true, message: '请选择操作日期' }]
      },
      diaOilTankOptions: [],
      diaOilTankData: []
    }
  },
  computed: {
    title () {
      return this.isEdit ? '编辑' : '新增'
    },
    isEdit () {
      return !this.$lodash.isEmpty(this.info)
    }
  },
  methods: {
    ...mapActions([
      'getDicOilTankList'
    ]),
    handleClose () {
      this.$emit('update:show', false)
    },
    // 处理HTTP请求错误
    handleRequestError () {
      this.$message.error('操作失败，请重试')
    },
    handleSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let params = {
            ...this.form
          }
          params.reservoirAreaType = 'XNYYPK'
          params.status = 0
          params.startTime = this.form.operateDate && this.form.operateDate[0]
          params.endTime = this.form.operateDate && this.form.operateDate[1]
          params.operateDate = ''
          let url
          if (this.isEdit) {
            url = 'manage/lifonda/inventoryXnyLoss/update'
          } else {
            url = 'manage/lifonda/inventoryXnyLoss/add'
          }
          HttpUtil.post(url, params)
            .then((res) => {
              if (res.success === true) {
                this.handleClose()
                this.$emit('reload')
                this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
              }
            })
            .catch(this.handleRequestError)
        }
      })
    },
    changeReservoirArea (val) {
      // 重置表单相关字段
      const resetFields = () => {
        this.form.oilTankCode = ''
        this.form.itemName = undefined
        this.form.itemCode = undefined
        this.diaOilTankData = []
        this.diaOilTankOptions = []
      }

      if (!val) {
        resetFields()
        return
      }

      let reservoirArea = this.reservoirAreaOptions.find(
        (item) => item.reservoirAreaName === val
      )

      if (reservoirArea) {
        this.form.reservoirAreaCode = reservoirArea.reservoirAreaCode
      }

      resetFields()
      this.getDicOilTankList({ reservoirAreaName: val })
        .then((res) => {
          if (res) {
            this.diaOilTankData = res
            this.diaOilTankOptions = res.map((item) => ({
              oilTankCode: item.oilTankCode,
              oilTankName: item.oilTankName
            }))
          }
        })
        .catch(this.handleRequestError)
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    changeOilTank (val) {
      if (!val) {
        this.form.itemName = undefined
        this.form.itemCode = undefined
        return
      }

      let oilTank = this.diaOilTankData.find(
        (item) => item.oilTankCode === val
      )

      if (oilTank) {
        this.form.itemName = oilTank.itemName
        this.form.itemCode = oilTank.itemCode
      }
    },
    // 计算助剂库存数
    calculateAdditiveQuantity () {
      if (this.form.operateDate !== undefined) {
        this.form.operateDate = null
      }
      if (this.form.additiveAccount !== null && this.form.additiveUse !== null) {
        this.form.additiveQuantity = this.form.additiveAccount - this.form.additiveUse
      }
    },
    changeOperateDate () {
      if (this.form.operateDate !== undefined) {
        this.form.operateDate = null
      }
    },
    // 盘点时间变化事件处理
    handleOperateDateChange () {
      if (this.form.reservoirAreaCode === '') {
        this.$message.error('请先选择库区')
        this.form.operateDate = null
        return false
      }
      if (this.form.oilTankCode === '') {
        this.$message.error('请先选择油罐')
        this.form.operateDate = null
        return false
      }
      let params = {}
      params.reservoirAreaCode = this.form.reservoirAreaCode
      params.oilTankCode = this.form.oilTankCode
      params.startTime = this.form.operateDate && this.form.operateDate[0]
      params.endTime = this.form.operateDate && this.form.operateDate[1]
      HttpUtil.post('manage/lifonda/inventoryXnyLoss/query', params).then((res) => {
        if (res) {
          this.form.realityOpeningQuantity = res.data.realityOpeningQuantity
          this.form.systemOpeningQuantity = res.data.systemOpeningQuantity
          this.form.systemInQuantity = res.data.systemInQuantity
          this.form.systemOutQuantity = res.data.systemOutQuantity
          this.form.systemEndingQuantity = res.data.systemEndingQuantity
          console.log(res.data.tankBottomQuantity)
          if (this.form.oilTankCode === '209') {
            // 盘锦库209罐月度盘亏放在罐底油字段上并用负数记录，要转为正数
            this.form.tankBottomQuantity = 0 - res.data.tankBottomQuantity
            // 理论库存 = 账面库存 - 总亏吨
            this.form.systemEndingQuantity = this.form.systemEndingQuantity - this.form.tankBottomQuantity
          } else {
            this.form.tankBottomQuantity = res.data.tankBottomQuantity
          }
          // 合理损耗 = 账面入库量 * 损耗率
          this.form.realityWastage = this.form.systemInQuantity * this.form.lossRate
          // 期末累计实存 = 账面库存 + 助剂账面
          this.form.realityEndingQuantityTotal = this.form.systemEndingQuantity + this.form.additiveAccount
          // 月度盘盈 = 实际库存 - 期末累计实存
          this.form.realityProfit = this.form.practicalQuantity - this.form.realityEndingQuantityTotal
          if (this.form.realityProfit <= 0) {
            this.form.realityProfit = 0
          } else {
            if (this.form.oilTankCode !== '209') {
              // 非盘锦209的其他库区油罐，盘盈需要减去罐底油
              this.form.realityProfit = this.form.realityProfit - this.form.tankBottomQuantity
            }
          }
          // 月度盘亏 = 期末累计实存 - 实际库存
          this.form.realityLoss = this.form.realityEndingQuantityTotal - this.form.practicalQuantity
          if (this.form.realityLoss <= 0) {
            this.form.realityLoss = 0
            this.form.realityWastageDiff = 0
            this.form.realityWastageRatio = 0
          } else {
            // 损耗差异 = 月度盘亏 - 合理损耗
            this.form.realityWastageDiff = this.form.realityLoss - this.form.realityWastage
            // 损耗率 = 月度盘亏 / (入库量 + 助剂量)
            if (this.form.realityLoss === 0 || (this.form.systemInQuantity === 0 && this.form.additiveQuantity === 0)) {
              this.form.realityWastageRatio = 0
            } else {
              this.form.realityWastageRatio = this.form.realityLoss / (this.form.systemInQuantity + this.form.additiveQuantity)
            }
          }
        }
      })
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        // 深拷贝表单数据，避免直接修改props
        if (this.isEdit && this.info) {
          this.form = { ...this.info }
        } else {
          // 重置为默认值
          this.form = {
            id: null,
            reservoirAreaCode: '',
            reservoirAreaName: '',
            oilTankCode: '',
            lossRate: null,
            practicalQuantity: null,
            additiveAccount: null,
            additiveUse: null,
            additiveQuantity: null,
            operateDate: new Date(),
            memo: ''
          }
        }
      }
    },
    // 同步父组件传递的选项数据
    oilTankOptions: {
      handler (newVal) {
        if (newVal && Array.isArray(newVal)) {
          this.diaOilTankOptions = [...newVal]
        }
      },
      immediate: true
    },
    oilTankData: {
      handler (newVal) {
        if (newVal && Array.isArray(newVal)) {
          this.diaOilTankData = [...newVal]
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.form-input {
  width: 193px;
}
</style>
